import React from 'react';
import AuroraFloatingCard from '../ui/AuroraFloatingCard';
interface PlaceholderPageProps {
  title: string;
  icon: React.ReactNode;
}
export function PlaceholderPage({
  title,
  icon
}: PlaceholderPageProps) {
  return <div className="space-y-8" data-id="element-1085">
      <div className="flex items-center gap-3" data-id="element-1086">
        <h1 className="text-3xl font-bold" data-id="element-1087">{title}</h1>
        {icon}
      </div>
      <AuroraFloatingCard data-id="element-1088">
        <div className="py-20 text-center" data-id="element-1089">
          <div className="flex justify-center mb-6 opacity-40" data-id="element-1090">{icon}</div>
          <h2 className="text-2xl font-semibold text-white mb-2" data-id="element-1091">
            {title} Sayfası
          </h2>
          <p className="text-gray-400 max-w-md mx-auto" data-id="element-1092">
            Bu sayfa şu anda yapım aşamasındadır. Çok yakında burada{' '}
            {title.toLowerCase()} ile ilgili tüm işlemleri
            gerçekleştirebileceksiniz.
          </p>
        </div>
      </AuroraFloatingCard>
    </div>;
}